import React from "react"

import classNames from "classnames"

import { CUSTOM_SERIES } from "../../enums"
import useChartOptions from "../../hooks/useChartOptions"
import { A } from "../index"
import Select from "../Select"

export default function AdditionalSeriesController() {
  const { handleCustomSeries } = useChartOptions()

  return (
    <>
      <Select
        onChange={handleCustomSeries}
        defaultSelected={CUSTOM_SERIES.AVERAGE}
      >
        <SeriesOption
          key={CUSTOM_SERIES.AVERAGE}
          className="highcharts-measure-xy"
        >
          기본
        </SeriesOption>
        <SeriesOption key={CUSTOM_SERIES.DRAW_SMA} className="custom-sma">
          이평선
        </SeriesOption>
        <SeriesOption key={CUSTOM_SERIES.BUY_SELL}>매집봉</SeriesOption>
      </Select>
      <div className="highcharts-toggle-annotations" />
    </>
  )
}

interface SeriesOptionProps {
  isActive?: boolean
  children: React.ReactNode
  className?: string
}

function SeriesOption({ children, className, ...props }: SeriesOptionProps) {
  return (
    <A
      {...props}
      className={classNames(
        "btn",
        {
          select: props.isActive,
        },
        className,
      )}
    >
      {children}
    </A>
  )
}
